module.exports = __webpack_public_path__ + "img/icon-success.f8e9e852.svg";